import { render, staticRenderFns } from "./OtherDamageDescription.vue?vue&type=template&id=77e7f748&scoped=true"
import script from "./OtherDamageDescription.vue?vue&type=script&lang=ts"
export * from "./OtherDamageDescription.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77e7f748",
  null
  
)

export default component.exports